import React from 'react';
import { connect } from 'react-redux';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Bar, BarChart, Legend, Label, ScatterChart, Scatter, Area, AreaChart } from 'recharts';
import * as statisticsActions from '../../actions/statisticsActions';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import Moment from 'react-moment';
import { FormControl, Grid, Row, Col } from 'react-bootstrap';

import { Button } from 'react-bootstrap'
import 'react-datepicker/dist/react-datepicker.css';
import { Link } from 'react-router-dom';
import * as constant from '../../constants/constant';
import $ from "jquery";
import * as dashboardActions from "../../actions/dashboardActions";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
// import DatetimeRangePicker from 'react-bootstrap-datetimerangepicker';
import DateTimeRangeContainer from 'react-advanced-datetimerange-picker'
class Statistics extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			startDate: moment().startOf('week'),
			endDate: moment().endOf('week'),
			//rate
			rateStats: [],
			statusDate2: '',

			filter2: '',
			dateTo2: { value: null, isValid: true, message: '' },
			dateFrom2: { value: null, isValid: true, message: '' },

			//app revenue
			appRevStats: [],
			medfixRevStats: [],
			statusDate3: '',
			filter3: '',
			dateTo3: { value: null, isValid: true, message: '' },
			dateFrom3: { value: null, isValid: true, message: '' },

			//Patient Vs appointment

			filter1: '',
			statistics: [],
			statusDate1: '',
			dateTo1: { value: null, isValid: true, message: '' },
			dateFrom1: { value: null, isValid: true, message: '' },

			//Medfix Revenue
			statusDate4: "",
			dateTo4: { value: null, isValid: true, message: '' },
			dateFrom4: { value: null, isValid: true, message: '' },
			logoutButton: false
		}


		this.onChange = this.onChange.bind(this);
		// rate
		this.rateVsPatientSearch = this.rateVsPatientSearch.bind(this);
		this.rateVsPatientReset = this.rateVsPatientReset.bind(this);
		//app revenue
		this.appRevenueSearch = this.appRevenueSearch.bind(this);
		this.appRevenueReset = this.appRevenueReset.bind(this);
		//date picker
		this.handleChangeTo = this.handleChangeTo.bind(this);
		this.handleChangeFrom = this.handleChangeFrom.bind(this);
		// Patient Vs appointment
		this.patientVsAppointmentSearch = this.patientVsAppointmentSearch.bind(this);
		this.patientVsAppointmentReset = this.patientVsAppointmentReset.bind(this);
		//Medfix Revenue
		this.getMedfixRevenueSearch = this.getMedfixRevenueSearch.bind(this);
		this.onLogoutclick = this.onLogoutclick.bind(this);
		this.toggle = this.toggle.bind(this)
		this._logout = this._logout.bind(this)
		this.handleApplyTabD = this.handleApplyTabD.bind(this)

		this.handleClick = this.handleClick.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);


		this.onClick = this.onClick.bind(this);
		this.applyCallback = this.applyCallback.bind(this);
	}

	_logout(event) {
		let userId = localStorage.getItem('userId')
		this.props.logoutAction.logout({ 'userId': userId })
		event.preventDefault();
		localStorage.clear();
		this.props.history.push('/');
	}
	toggle() {
		var windowWidth = $(window).width();
		if (windowWidth < 768) {
			$("body").toggleClass("sidebar-open");
		} else {
			$("body").toggleClass("sidebar-collapse");
		}
	}
	handleApplyTabD(startDate, endDate) {
		this.setState({
			dateFrom1: {
				value: startDate,
			},
			dateTo1: {
				value: endDate,
			},
			startDate,
			endDate,
			statusDate1: ''

		})
		return
		
		let that = this;
		var state = that.state;
		state.dateFrom1.value = startDate
		state.dateTo1.value = endDate
		state.startDate = startDate,
			state.endDate = endDate,
			state.statusDate1 = ''
		this.setState(state);
		this.patientVsAppointmentSearch()
	}
	handleChangeTo(name, date) {
		var state = this.state;
		state[name].message = '';
		state[name].value = date;
		this.setState(state);
	}

	handleChangeFrom(name, date) {
		var state = this.state;
		state[name].message = '';
		state[name].value = date;
		this.setState(state);
	}

	onChange(event) {

		var state = this.state;
		if (event.target.name == "filter1") {
			if (event.target.value == "1" || event.target.value == "2") {
				state.statusDate1 = (event.target.value == "1") ? "week" : "month";
				if (event.target.value == "1") {
					state.startDate = moment().startOf('week');
					state.endDate = moment().endOf('week');
				} else {
					state.startDate = moment().startOf('month');
					state.endDate = moment().endOf('month');
				}
			} else {
				state.statusDate1 = "";
			}
			state.filter1 = event.target.value;
			this.setState(state);
			this.patientVsAppointmentSearch();
		}
		else if (event.target.name == "filter2") {
			if (event.target.value == "1" || event.target.value == "2") {
				state.statusDate2 = (event.target.value == "1") ? "week" : "month";
			} else {
				state.statusDate2 = "";
			}
			state.filter2 = event.target.value;
			this.setState(state);
			this.rateVsPatientSearch();
		} else if (event.target.name == "filter3") {

			if (event.target.value == "1" || event.target.value == "2") {
				state.statusDate3 = (event.target.value == "1") ? "week" : "month";
			} else {
				state.statusDate3 = "";
			}
			state.filter3 = event.target.value;
			this.setState(state);
			this.appRevenueSearch();
		}
		else if (event.target.name == "filterMrev") {
			if (event.target.value == "1" || event.target.value == "2") {
				state.statusDate4 = (event.target.value == "1") ? "week" : "month";
			} else {
				state.statusDate4 = "";
			}
			state.filterMrev = event.target.value;
			this.setState(state);
			this.getMedfixRevenueSearch();
		}

	}

	rateVsPatientSearch() {
		if ((this.state.filter2 == "1" || this.state.filter2 == "2" || this.state.filter2 == "") || (this.state.filter2 == "3" && this.state.dateTo2.value != null && this.state.dateFrom2.value != null && this.state.dateTo2.message == '')) {
			var obj = {
				doctorId: localStorage.getItem('userId'),
				filter: this.state.statusDate2,
				fromdate: (this.state.dateFrom2.value == null) ? '' : this.state.dateFrom2.value,
				todate: (this.state.dateTo2.value == null) ? '' : this.state.dateTo2.value
			}
			this.props.actions.getRateVsPatients(obj);
		} else {
			var state = this.state;
			state.dateTo2.message = (this.state.dateTo2.value == null) ? "Please select start date" : "";
			state.dateFrom2.message = (this.state.dateFrom2.value == null) ? "Please select end date" : "";
			this.setState(state);
		}

	}

	rateVsPatientReset() {
		var state = this.state;
		state.statusDate2 = '';
		state.filter2 = '';
		state.dateTo2.value = null;
		state.dateFrom2.value = null;

		this.setState(state);
	}

	appRevenueSearch() {

		if ((this.state.filter3 == "1" || this.state.filter3 == "2" || this.state.filter3 == "") || (this.state.filter3 == "3" && this.state.dateTo3.value != null && this.state.dateFrom3.value != null && this.state.dateTo3.message == '')) {
			var obj = {
				doctorId: localStorage.getItem('userId'),
				filter: this.state.statusDate3,
				fromdate: (this.state.dateFrom3.value == null) ? '' : this.state.dateFrom3.value,
				todate: (this.state.dateTo3.value == null) ? '' : this.state.dateTo3.value
			}
			this.props.actions.getAppointmentRevenue(obj);
		} else {
			var state = this.state;
			state.dateTo3.message = (this.state.dateTo3.value == null) ? "Please select start date" : "";
			state.dateFrom3.message = (this.state.dateFrom3.value == null) ? "Please select end date" : "";
			this.setState(state);
		}
	}

	appRevenueReset() {
		var state = this.state;
		state.statusDate3 = '';
		state.filter3 = '';
		state.dateTo3.value = null;
		state.dateFrom3.value = null;

		this.setState(state);
	}

	getMedfixRevenueSearch() {
		
		if ((this.state.filterMrev == "1" || this.state.filterMrev == "2" || this.state.filterMrev == "") || (this.state.filterMrev == "3" && this.state.dateTo4.value != null && this.state.dateFrom4.value != null && this.state.dateTo4.message == '')) {
			var obj = {
				doctorId: localStorage.getItem('userId'),
				filter: this.state.statusDate4,
				fromdate: (this.state.dateFrom4.value == null) ? '' : this.state.dateFrom4.value,
				todate: (this.state.dateTo4.value == null) ? '' : this.state.dateTo3.value
			}
			this.props.actions.getMedfixRevenue(obj);
		} else {
			var state = this.state;
			state.dateTo4.message = (this.state.dateTo4.value == null) ? "Please select start date" : "";
			state.dateFrom4.message = (this.state.dateFrom4.value == null) ? "Please select end date" : "";
			this.setState(state);
		}
	}
	patientVsAppointmentSearch() {

		if ((this.state.filter1 == "1" || this.state.filter1 == "2" || this.state.filter1 == "") || (this.state.filter1 == "3" && this.state.dateTo1.value != null && this.state.dateFrom1.value != null && this.state.dateTo1.message == '')) {
			var obj = {
				doctorId: localStorage.getItem('userId'),
				filter: this.state.statusDate1,
				fromdate: (this.state.dateFrom1.value == null) ? '' : this.state.dateFrom1.value,
				todate: (this.state.dateTo1.value == null) ? '' : this.state.dateTo1.value
			}
			this.props.actions.getPatientVsAppointments(obj);
			this.props.actions.getRateVsPatients(obj);
			this.props.actions.getAppointmentRevenue(obj);
			this.props.actions.getMedfixRevenue(obj);
		} else {
			var state = this.state;
			state.dateTo1.message = (this.state.dateTo1.value == null) ? "Please select start date" : "";
			state.dateFrom1.message = (this.state.dateFrom1.value == null) ? "Please select end date" : "";
			this.setState(state);
		}
	}

	patientVsAppointmentReset() {
		var state = this.state;
		state.statusDate1 = '';
		state.filter1 = '';
		state.dateTo1.value = null;
		state.dateFrom1.value = null;

		this.setState(state);
	}

	componentDidMount() {
	}

	componentWillMount() {
		var obj = {
			doctorId: localStorage.getItem('userId'),
			filter: "week"
		}
		this.props.actions.getPatientVsAppointments(obj);
		this.props.actions.getRateVsPatients(obj);
		this.props.actions.getAppointmentRevenue(obj);
		this.props.actions.getMedfixRevenue(obj);

	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			statistics: nextProps.statistics,
			rateStats: nextProps.rateStats,
			appRevStats: nextProps.appRevStats,
			medfixRevStats: nextProps.medfixRevStats
		})
	}

	onLogoutclick(data) {
		if (this.state.logoutButton == false) {
			this.setState({
				logoutButton: true
			});
		}
		else {
			this.setState({
				logoutButton: false
			});
		}
	}

	handleOutsideClick(e) {
		// ignore clicks on the component itself
		if (this.node && this.node.contains(e.target)) {
			return;
		}

		this.handleClick();
	}
	handleClick() {
		if (!this.state.logoutButton) {
			// attach/remove event handler
			document.addEventListener('click', this.handleOutsideClick, false);
		} else {
			document.removeEventListener('click', this.handleOutsideClick, false);
		}

		this.setState(prevState => ({
			logoutButton: !prevState.logoutButton,
		}));
	}


	renderPickerAutoApply(local, maxDate) {
		let value = `${this.state.startDate.format(
			'DD-MM-YYYY',
		)} - ${this.state.endDate.format('DD-MM-YYYY')}`;
		let locald = {
			"format":"DD-MM-YYYY",
			"sundayFirst" : true
		}
		return (
			<DateTimeRangeContainer
				ranges={false}
				format="DD-MM-YYYY"
				start={this.state.startDate}
				end={this.state.endDate}
				// local={local}
				//   maxDate={maxDate}
				applyCallback={this.applyCallback}
				rangeCallback={this.rangeCallback}
				autoApply
				local={local}
			>
				{/* <FormControl
						id="formControlsTextB"
						type="text"
						label="Text"
						placeholder="Enter text"
						style={{ cursor: 'pointer' }}
						disabled
						value={value}
					/> */}
				<div className="input-group">
					<input type="text" className="form-control marginleft" value={value} />
					<span className="input-group-btn">
						<Button className="default date-range-toggle statsCal">
							<i className="fa fa-calendar" />
						</Button>
					</span>
				</div>
			</DateTimeRangeContainer>
		);
	}


	applyCallback(startDate, endDate) {
		let that = this;
		var state = that.state;
		state.dateFrom1.value = startDate
		state.dateTo1.value = endDate
		state.startDate = startDate,
			state.endDate = endDate,
			state.statusDate1 = ''
		this.setState(state);
		// 
		// 
		// 
		// this.setState({
		//   startDate: startDate,
		//   endDate: endDate,
		// });
		this.patientVsAppointmentSearch();
	}

	rangeCallback(index, value) {
		
	}

	onClick() {
		let newStart = moment(this.state.startDate).subtract(3, 'days');
		// 
		// 
		this.setState({ startDate: newStart });
	}


	render() {

		let now = new Date();
		let start = moment(
			new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0),
		);
		let end = moment(start)
			.add(1, 'days')
			.subtract(1, 'seconds');
		// let ranges = {
		// 	'Today Only': [moment(start), moment(end)],
		// 	'Yesterday Only': [
		// 		moment(start).subtract(1, 'days'),
		// 		moment(end).subtract(1, 'days'),
		// 	],
		// 	'3 Days': [moment(start).subtract(3, 'days'), moment(end)],
		// 	'5 Days': [moment(start).subtract(5, 'days'), moment(end)],
		// 	'1 Week': [moment(start).subtract(7, 'days'), moment(end)],
		// 	'2 Weeks': [moment(start).subtract(14, 'days'), moment(end)],
		// 	'1 Month': [moment(start).subtract(1, 'months'), moment(end)],
		// 	'90 Days': [moment(start).subtract(90, 'days'), moment(end)],
		// 	'1 Year': [moment(start).subtract(1, 'years'), moment(end)],
		// };
		let local = {
			format: 'DD-MM-YYYY HH:mm',
			sundayFirst: false,
		};
		// let maxDate = moment(start).add(24, 'hour');

		const getIntroOfPage = (label) => {
			if (label === 'CS') {
				label = 'Courtesy of Staff'
				return label;
			} if (label === 'CC&C') {
				return "Clinic Cleanliness & Comfort";
			} if (label === 'WT') {
				return "Waiting Time";
			} if (label === 'CC') {
				return 'Consultation Cost';
			} if (label === 'QC') {
				return 'Quality of Care';
			}
		};
		const CustomTooltip = ({ active, payload, label }) => {
			if (active) {
				return (
					<div className="custom-tooltips ">
						<p className="label">{getIntroOfPage(label)}</p>
						<p className="labelName">{`Rating: ${payload[0].value}`}</p>
						{/* <p className="desc">Anything you want can be displayed here.</p> */}
					</div>
				);
			}

			return null;
		}
		// let start = this.state.startDate.format('YYYY-MM-DD');
		// let end = this.state.endDate.format('YYYY-MM-DD');
		let label = start + ' - ' + end;
		if (start === end) {
			label = start;
		}

		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		const data = [
			{ name: 'Page A', uv: 4000, amt: 2400 },
			{ name: 'Page B', uv: 3000, amt: 2210 },
			{ name: 'Page C', uv: 2000, amt: 2290 },
			{ name: 'Page D', uv: 2780, amt: 2000 },
			{ name: 'Page E', uv: 1890, amt: 2181 },
			{ name: 'Page F', uv: 2390, amt: 2500 },
			{ name: 'Page G', uv: 3490, amt: 2100 },
		];
		// const data1 = [{ name: "Appointments", Patients: 2, Appointments: 13 }];

		const obj = [{
			name: "eer",
			count: 33
		}]
		var defaultImagePath = user.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png';

		if (user.image == constant.DEFAULT_USER_IMAGE) {
			var imagePath = user.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png';
		} else {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		}
		// var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var condition = (((user.userName != undefined || user.gender != undefined) && user.availabilityCount > 0) && user.isVerified == '2');
		var userType = localStorage.getItem('userType');
		return (
			<div>
				<header className="main-header">
				<Link to={condition ? "/specialist/my-appointment" : null} className="logo">						<span className="logo-mini">{userType === 'specialist' ? <img src={require('../../images/img/logo_er_ms_specialist.png')} alt="" /> : <img src={require('../../images/img/logo_er_ms.png')} alt="" />}</span>
						<span className="logo-lg">{userType === 'specialist' ? <img src={require('../../images/img/logo_er.png')} alt="" /> : <img src={require('../../images/img/logo_er_old.png')} alt="" />}</span> </Link>
					<nav className="navbar navbar-static-top" role="navigation">
						<Link href="#" className="sidebar-toggle" data-toggle="push-menu" role="button" onClick={this.toggle}> <img src={require('../../images/img/menu_list.svg')} alt="" /> <span className="sr-only">Toggle navigation</span> </Link>
						<div className="navbar-custom-menu">
							<ul className="nav navbar-nav">
								<li ref={node => { this.node = node; }} onClick={this.handleClick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>
									<Link href="#" className="dropdown-toggle" data-toggle="dropdown">
										<img src={imagePath} className="user-image" alt="User Image" onError={(e) => { e.target.src = defaultImagePath }} />
										<span className="hidden-xs name-capitalize">{user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}</span> </Link>

									<ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

										<li className="user-setting">	<Link to={{ pathname: "/specialist/my-settings", state: 1 }}>

											<img
												src={require('../../images/Slicing/Settings-profile.png')}
												className="user-image"
												alt="User Image"
												onError={e => {
													e.target.src = defaultImagePath;
												}}
											/>
											<span>Settings</span>
										</Link></li>
										<li
											className="user-footer passwordLink"
										// style={{ textAlign: "center" }}
										>

											<Link

												className="uploadLink"
												onClick={this._logout}
											>
												<img
													src={require('../../images/Slicing/logout-profile.png')}
													className="user-image"
													alt="User Image"
													onError={e => {
														e.target.src = defaultImagePath;
													}}
												/>
												<span>	Sign out</span>
											</Link>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</nav>
				</header>
				<div className="content-wrapper">
					<section className="content container-fluid">
						<div className="row">
							<div className="col-md-12">
								<div className="boxMrgB proCalendar">
									<div className="nav-tabs-custom">
										<ul className="nav nav-tabs">
											<li>
												<Link to="#tab_1" data-toggle="tab" className="active show">Stats</Link>
											</li>

										</ul>
										<div className="row">
											<div className="col-md-12">
												<div className="tab-content tabother">
													<div className="row">
														<form className="form-inline width-100">
															<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 tabletpadding0">
																<div className="rows">
																	<div className="form-group inputBg dateBrt beforenone a-auto">
																		<label for="exampleInputEmail1"> Value Range</label>
																		<select className="form-control selectBg seltweekly" name="filter1" value={this.state.filter1} onChange={this.onChange.bind(this)}>
																			<option value="1">Weekly</option>
																			<option value="2">Monthly</option>
																			{/* <option>Yearly</option> */}
																		</select>
																	</div>
																</div>

																<div className=" m-t-20">
																	{this.state.statistics && this.state.statistics.length > 0 ?
																		<BarChart width={500} height={315} data={this.state.statistics} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
																			<CartesianGrid strokeDasharray="3 3" />
																			{/* <XAxis dataKey="_id" /> */}
																			<YAxis>
																				<Label angle={-90} value='No. of Patients' position='insideLeft' style={{ textAnchor: 'middle', color: '#666666' }} />
																			</YAxis>
																			<Tooltip />
																			<Bar dataKey="Patient2" barSize={30} fill="#00b5e8" name="Consulted" />
																			<Bar dataKey="Patient3" barSize={30} fill="#000000" name="No Show Specialist" />
																			<Bar dataKey="Patient4" barSize={30} fill="#A9A9A9" name="No Show Patient" />
																			<Bar dataKey="Patient6" barSize={30} fill="#FF0000" name="Cancelled by Specialist" />
																			<Bar dataKey="Patient7" barSize={30} fill="#8B0000" name="Cancelled by Patient" />
																		</BarChart> : <div className='nodatafound' style={{}}>No data found</div>
																	}
																	<p className="overall-title">Overall Appointment History</p>
																</div>
															</div>
															<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 tabletpadding0">
																<div className="form-inline inputBg dateBrt beforenone a-auto width100merge">
																	{/* <DatetimeRangePicker
																startDate={this.state.startDate}
																endDate={this.state.endDate}
																onApply={this.handleApplyTabD}
															// ranges={this.state.ranges}

															>
																<div className="input-group">
																	<input type="text" className="form-control marginleft" value={label} />
																	<span className="input-group-btn">
																	</span>
																</div>
															</DatetimeRangePicker> */}
																	{this.renderPickerAutoApply(local)}
																	{/* <Button className="default date-range-toggle">
																			<i className="fa fa-calendar" />
																		</Button> */}
																</div>
																<div className="m-t-20">
																	{
																		this.state.medfixRevStats && this.state.medfixRevStats.length > 0 ?
																			<BarChart width={500} height={315} data={this.state.medfixRevStats}
																				margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
																				<CartesianGrid strokeDasharray="3 3" />
																				{/* <XAxis dataKey="Mode" /> */}
																				<YAxis orientation="left" >
																					<Label angle={-90} value='Revenue' position='insideLeft' style={{ textAnchor: 'middle', color: '#666666' }} />
																				</YAxis>
																				<Tooltip />
																				<Bar dataKey="Revenue0" fill="#ff7245" barSize={25} name="ModeO" />
																				<Bar dataKey="RevenueF" fill="#00b5e8" barSize={25} name="ModeF2F" />
																			</BarChart> :
																			<div className='nodatafound' style={{}}>No data found</div>
																	}
																	<p className="overall-title">Revenue Share with Medfix</p>
																</div>
															</div>

														</form>
													</div>


													<div className="row">
														<div className="col-md-12">
															<div className="row" style={{ marginTop: 20 }}>
																<form className="form-inline width-100">
																	<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 tabletpadding0">
																		<div className="rows">
																			{/* <div className="form-group inputBg dateBrt beforenone a-auto">
																				<label for="exampleInputEmail1"> Value Range</label>
																				<select className="form-control selectBg seltweekly" name="filter2" value={this.state.filter2} onChange={this.onChange.bind(this)}>
																					<option value="1">Weekly</option>
																					<option value="2">Monthly</option>
																				</select>
																			</div> */}
																		</div>

																		<div className="m-t-20">

																			<div className="">
																				{this.state.rateStats && this.state.rateStats.length > 0 ?
																					<BarChart width={500} height={300} data={this.state.rateStats} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
																						<CartesianGrid strokeDasharray="3 3" />
																						{/* <XAxis dataKey="abriv" /> */}
																						<YAxis orientation="left" >
																							<Label angle={-90} value='No. of Patients' position='insideLeft' style={{ textAnchor: 'middle', color: '#666666' }} />
																						</YAxis>
																						<Tooltip /* content={<CustomTooltip />} */ />
																						<Bar dataKey="averageValue1" /* name="Average Rating" */ barSize={15} fill="#00b5e8" name="Clinic Cleanliness & Comfort" />
																						<Bar dataKey="averageValue2" /* name="Average Rating" */ barSize={15} fill="#00b5e8" name="Courtesy of Staff" />
																						<Bar dataKey="averageValue3" /* name="Average Rating" */ barSize={15} fill="#00b5e8" name="Quality of Care" />
																						<Bar dataKey="averageValue4" /* name="Average Rating" */ barSize={15} fill="#00b5e8" name="Waiting Time" />
																						<Bar dataKey="averageValue5" /* name="Average Rating" */ barSize={15} fill="#00b5e8" name="Consultation Cost" />
																						{/* <Bar dataKey="Patient2" barSize={30} fill="#00b5e8" name="Consulted" />
																			<Bar dataKey="Patient3" barSize={30} fill="#000000" name="No Show Specialist" />
																			<Bar dataKey="Patient4" barSize={30} fill="#A9A9A9" name="No Show Patient" />
																			<Bar dataKey="Patient6" barSize={30} fill="#FF0000" name="Cancelled by Specialist" />
																			<Bar dataKey="Patient7" barSize={30} fill="#8B0000" name="Cancelled by Patient" /> */}
																						{/* <Bar dataKey="averageValue" name="Patient" barSize={35} fill="#22b89f" />
																			<Bar dataKey="averageValue" name="Patient" barSize={35} fill="#ff7245" />
																			<Bar dataKey="averageValue" name="Patient" barSize={35} fill="#4d4d4d" />
																			<Bar dataKey="averageValue" name="Patient" barSize={35} fill="#FA4463" /> */}
																					</BarChart>
																					: <div className='nodatafound' style={{}}>No data found</div>
																				}
																				<p className="overall-title" style={{ whiteSpace: "nowrap" }}>Overall Patient Satisfaction</p>
																			</div>
																		</div>

																	</div>
																	<div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 tabletpadding0">
																		{/* <div className="form-group inputBg dateBrt beforenone a-auto">
																			<label for="exampleInputEmail1"> Value Range</label>
																			<select className="form-control selectBg seltweekly" name="filter3" value={this.state.filter3} onChange={this.onChange.bind(this)}>
																				<option value="1">Weekly</option>
																				<option value="2">Monthly</option>
																			</select>
																		</div> */}
																		<div className="m-t-20">
																			{
																				this.state.appRevStats && this.state.appRevStats.length > 0 ?
																					<BarChart width={500} height={300} data={this.state.appRevStats}
																						margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
																						<CartesianGrid strokeDasharray="3 3" />
																						{/* <XAxis dataKey="Mode" /> */}
																						<YAxis orientation="left" >
																							<Label angle={-90} value='Revenue' position='insideLeft' style={{ textAnchor: 'middle', color: '#666666' }} />
																						</YAxis>
																						{/* <YAxis yAxisId="right" orientation="right" stroke="#82ca9d" /> */}
																						<Tooltip />
																						{/* <Legend /> */}
																						<Bar dataKey="RevenueF" fill="#00b5e8" barSize={25} name="ModeF"/>
																						<Bar dataKey="RevenueO" fill="#ff7245" barSize={25} name="ModeO"/>
																						{/* <Bar yAxisId="right" dataKey="Patients" fill="#82ca9d" barSize={30} /> */}
																					</BarChart> :
																					<div className='nodatafound' style={{}}>No data found</div>
																			}
																			<p className="overall-title">Revenue by Appointment Mode</p>
																		</div>
																	</div>
																</form>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					<div className="Copyrightafterlogin">
						<p>Medfix &copy; 2018. All rights reserved</p>
					</div>
				</div >
			</div>
		)
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		statistics: state.statistics.statistics,
		rateStats: state.statistics.rateStats,
		appRevStats: state.statistics.appRevStats,
		medfixRevStats: state.statistics.medfixRevStats
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(statisticsActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch)

	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Statistics);



